<template>
  <base-spinner :open="isloading"></base-spinner>
  <div class="col-12 col-lg-9 mt-4 mt-lg-0">
    <div class="card">
      <div class="card-header">
        <h5>Change Password</h5>
      </div>
      <div class="card-divider"></div>
      <div class="card-body card-body--padding--2">
        <base-message
          v-if="!isloading"
          :servermessages="servermessages"
        ></base-message>
        <div class="row no-gutters">
          <div class="col-12 col-lg-7 col-xl-6">
            <form>
              <div
                class="form-group has-icon"
                :class="{ invalid: currentpassvalid === 'invalid' }"
              >
                <label for="password-current">Current Password</label>
                <base-password-input
                  v-model="currentpass"
                  placeholder="Current Password"
                  @validate-input="validateCurrentPass"
                >
                  <template #message>
                    <small class="invalid-text" v-if="currentpassvalid === 'invalid'">
                      <i>Please enter your old password.</i>
                    </small>

                  </template>
                </base-password-input>
              </div>
              <div
                class="form-group has-icon"
                :class="{ invalid: newpassvalid === 'invalid' }"
              >
                <label for="password-new">New Password</label>
                <base-password-input
                  v-model="newpass"
                  placeholder="New Password"
                  @validate-input="validateNewPass"
                >
                  <template #message>
                    <small class="invalid-text" v-if="newpassvalid === 'invalid'">
                      <i>Please enter a new password.</i>
                    </small>
                  </template>
                </base-password-input>


              </div>
              <div
                class="form-group has-icon"
                :class="{ invalid: verifypassvalid === 'invalid' }"
              >
                <label for="password-confirm">Repeat New Password</label>
                <base-password-input
                  v-model="verifypass"
                  placeholder="Repeat New Password"
                  @validate-input="validateVerifyPass"
                >
                  <template #message>
                    <small
                      class="invalid-text"
                      v-if="verifypassvalid === 'invalid'"
                    >
                      <i>Please enter verify your new password.</i>
                    </small>
                  </template>

                </base-password-input>


              </div>
              <!-- <div id="message">
                <h4 class="block-header__title-check-stock">
                  Password must contain the following:
                </h4>
                <p id="letter" class="invalid">A <b>lowercase</b> letter</p>
                <p id="capital" class="invalid">
                  A <b>capital (uppercase)</b> letter
                </p>
                <p id="number" class="invalid">A <b>number</b></p>
                <p id="length" class="invalid">Minimum <b>8 characters</b></p>
              </div> -->
              <div class="form-group mb-0">
                <button
                  type="button"
                  class="btn btn-primary mt-3"
                  @click.prevent="changePassword"
                >
                  Change
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <base-dialog title="Confirm Password Change" @close="cancelChange" :open="changepasswordclicked">
    <template #default>
      <p>Are you sure you want to change your password?</p>
    </template>
    <template #actions>
      <button type="button" class="btn btn-sm btn-secondary mr-2" @click="cancelChange">
        No
      </button>
      <button type="button" class="btn btn-sm btn-primary" @click="confirmChange">
        Yes
      </button>
    </template>
  </base-dialog>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
  data() {
    return {
      currentpass: "",
      newpass: "",
      verifypass: "",
      currentpassvalid: "pending",
      newpassvalid: "pending",
      verifypassvalid: "pending",
      changepasswordclicked: false,
      isloading: false,
      servermessages: [],
    };
  },
  methods: {
    changePassword() {
      this.changepasswordclicked = true;
    },
    cancelChange() {
      this.changepasswordclicked = false;
    },
    confirmChange() {
      this.isloading = true;
      this.changepasswordclicked = false;

      axiosvl.post(this.$store.getters['api/change_password_uri'],
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                // "HOSTURL": { "value": this.$store.getters.hosturl },
                "LW3SFID": { "value": this.$store.getters.storefront },
                "LW3WEBUSR": { "value": this.$store.getters.userid },
                "LW3USRPAS": { "value": this.currentpass },
                "LW3USRNPW": { "value": this.newpass },
                "LW3USRPS2": { "value": this.verifypass }
              },
            },
          }
      )
      .then((response) => {
        this.isloading = false;
        const fields = response.data.webroutine.fields;

        this.serverstatus = fields.LW3RETCOD.value;

        const messages = [];
        const wrmessages = response.data.webroutine.messages;

        for (var i = 0; i < wrmessages.length; i++) {
          messages.push(wrmessages[i]);
        }

        if (this.serverstatus === "OK") {
          this.currentpass = '', this.newpass = '', this.verifypass = '';
        } else {
          if (messages.length === 0) {
            messages.push("Something went wrong. Please try again later.");
          }
        }  

        this.servermessages = messages;
      })
      .catch((error) => {
        this.servermessages.push(
          "Something went wrong. Please try again later."
        );
        this.isloading = false;
        console.error("error - " + error);
      });
    },
    validateCurrentPass() {
      if (this.currentpass === "") {
        this.currentpassvalid = "invalid";
      } else {
        this.currentpassvalid = "valid";
      }
    },
    validateNewPass() {
      if (this.newpass === "") {
        this.newpassvalid = "invalid";
      } else {
        this.newpassvalid = "valid";
      }
    },
    validateVerifyPass() {
      if (this.verifypass === "") {
        this.verifypassvalid = "invalid";
      } else {
        this.verifypassvalid = "valid";
      }
    },
  },
  created() {
    this.isloading = false;
  },
};
</script>


<style scoped>
.form-group.has-icon {
  position: relative;
}

.form-group.invalid input,
.form-group.invalid label {
  border-color: #cb1818;
}

.form-group.invalid label,
.form-group.invalid .invalid-text {
  color: #cb1818;
}
</style>